/**
 * 根路由入口（按平台懒加载 H5 / PC）
 *
 * @module router
 */
import { MiniRoute, PatternBrowserRouter } from '@yimoka/mini-router';
import { ConfigProvider } from '@yimoka/react';
import { lazy, Suspense, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { i18n } from '@/locales/i18n';
import { getPlatform, PLATFORM_H5, setLanguage, SUPPORT_LANGUAGES } from '@/root';

import { pathnameHasLanguagePrefix, resolvePathLanguage } from './lang';

const LazyH5Router = lazy(() => import('./h5').then(m => ({ default: m.H5Router })));
const LazyPcRouter = lazy(() => import('./pc').then(m => ({ default: m.PcRouter })));

const PageRouter = () => {
  const platform = getPlatform();
  const Router = platform === PLATFORM_H5 ? LazyH5Router : LazyPcRouter;
  return (
    <ConfigProvider value={{ useNavigate, useRouteParams: useParams, useLocation }}>
      <Suspense fallback={<div style={{ padding: 16, textAlign: 'center' }}>加载中…</div>}>
        <Router />
      </Suspense>
    </ConfigProvider>
  );
};

const LangRouter = ({ lang }: { lang?: string }) => {
  useEffect(() => {
    const pathLang = resolvePathLanguage(lang);
    if (!pathLang) return;

    setLanguage(pathLang);
    if (i18n.language !== pathLang) {
      void i18n.changeLanguage(pathLang);
    }
  }, [lang]);

  const hasLangPrefix = pathnameHasLanguagePrefix();
  return (
    <PatternBrowserRouter key={lang} base={(lang || hasLangPrefix) ? '/' : undefined}>
      <PageRouter />
    </PatternBrowserRouter>
  );
};

export const RootRouter = () => (
  <>
    {SUPPORT_LANGUAGES.map(item => (
      <MiniRoute key={item.path} component={<LangRouter lang={item.value} />} path={`/${item.path}/*`} />
    ))}
    <MiniRoute component={<LangRouter />} path="*" />
  </>
);
